import { getIcons } from '_helpers';
import { AlertsAndPreAlertsTable } from '.';
import { ReturnButton } from '_components';
import { useNavigate } from 'react-router-dom';
import { AlertOverview } from './Alerts.Overview';

export { AlertsManagement };

function AlertsManagement() {
    const navigate = useNavigate();

    return (         
        <div >
            <div className='ml-10 pl-12'>
                <ReturnButton />
            </div>   
            <div className='mx-10 px-12'>        
                <div className='flex justify-end w-full mr-10'>
                    <button className='btn-custom btn-custom-primary' onClick={() => navigate('/alertes/add')}>
                        <img src={getIcons('addOutlined')} className='btn-custom-icon mt-[-4px]' alt='manage alerts' />
                        Créer une pré-alerte
                    </button>
                </div>
                <div className='grid grid-cols-5 h-full mt-4'>
                    <div className="col-span-3 h-full">
                        <AlertsAndPreAlertsTable />  
                    </div>
                    <div className="col-span-2 h-full pt-16">                     
                        <AlertOverview />
                    </div>
                </div> 
            </div> 
        </div>
        
    );
}